import FormLogisticCreate from './FormLogisticCreate';
import FormLogisticDelete from './FormLogisticDelete';
import FormLogisticFilter from './FormLogisticFilter';
import FormLogisticUpdate from './FormLogisticUpdate';
import FormLogisticOrigin from './FormLogisticOrigin';

export default Object.assign(
  {},
  {
    Create: FormLogisticCreate,
    Update: FormLogisticUpdate,
    Delete: FormLogisticDelete,
    Filter: FormLogisticFilter,
    Origin: FormLogisticOrigin,
  },
);
